const strings = {
  en: {
    heroLabel: 'CONTACT',
    heroTitlePrefix: "Let's ",
    heroTitleAccent: 'Talk',
    heroSubtitle: 'Have questions about SAPOT AI? Our team is ready to help you get started.',
    firstName: 'First Name',
    lastName: 'Last Name',
    workEmail: 'Work Email',
    company: 'Company',
    teamSize: 'Team Size',
    selectTeamSize: 'Select team size',
    message: 'Message',
    sendMessage: 'Send Message',
    waPrefix: 'Hi SAPOT AI, my name is',
    waFrom: 'from',
    emailUs: 'Email Us',
    callUs: 'Call Us',
    visitUs: 'Visit Us',
    popupCompany: 'SAPOT AI (Dataverse Sdn Bhd)',
  },
  zh: {
    heroLabel: '联系我们',
    heroTitlePrefix: '与我们',
    heroTitleAccent: '交流',
    heroSubtitle: '对 SAPOT AI 有任何疑问？我们的团队随时为您提供帮助，助您轻松上手。',
    firstName: '名字',
    lastName: '姓氏',
    workEmail: '工作邮箱',
    company: '公司',
    teamSize: '团队规模',
    selectTeamSize: '请选择团队规模',
    message: '留言',
    sendMessage: '发送消息',
    waPrefix: '您好 SAPOT AI，我叫',
    waFrom: '，来自',
    emailUs: '邮件联系',
    callUs: '电话联系',
    visitUs: '实地拜访',
    popupCompany: 'SAPOT AI（Dataverse Sdn Bhd）',
  },
};

export default strings;
